import React, { useEffect } from 'react';
import useBreadcrumb from 'src/hooks/useBreadcrumb';
import TitleBar from 'src/components/layout/TitleBar';
//import PropTypes from 'prop-types';

const HomeTenantAdmin = () => {
  const { setBreadcrumb, dropBreadcrumb } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumb([
      {
        title: 'Tenant Admin',
      },
    ]);

    return () => {
      dropBreadcrumb();
    };
  }, []);

  return (
    <>
      <TitleBar title='Tenant Admin' />
    </>
  );
};

// HomeTenantAdmin.propTypes = {};

export default HomeTenantAdmin;
